/* KORE Owner Panel — lo propio de la sección «Área propietarios»
   (sections/kore-owner-panel.liquid).

   El movimiento (levantarse con el scroll, inclinarse hacia el ratón, la
   entrada y las cifras que cuentan) lo pone el motor compartido
   assets/kore-stage3d.js. Aquí queda lo que es solo de este panel:
   1. La hora de «Actualizado a las…», la del visitante.
   2. Posar el ratón (o tocar) un producto enseña su reparto por talla,
      igual que en el panel real.
   3. Cada una de las cuatro ventajas ilumina su zona del panel.

   Nada de esto mueve el objeto, así que sigue activo con movimiento
   reducido. */
(function () {
  'use strict';
  if (window.KoreOwnerPanel) return;
  window.KoreOwnerPanel = true;

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* Posición vertical de un nodo dentro de su tarjeta, por offsets: el rect
     de pantalla viene proyectado por el 3D y no sirve para colocar nada. */
  function topEn(el, ancestro) {
    var y = 0;
    while (el && el !== ancestro) { y += el.offsetTop; el = el.offsetParent; }
    return y;
  }

  // ── Reparto por talla ─────────────────────────────────────────
  function colocarPop(u) {
    if (!u.pop || !u.activa) return;
    var row = u.activa;
    var top = topEn(row, u.prods);
    var aire = row.offsetHeight * 0.18;
    /* Se abre hacia abajo si cabe en la tarjeta o asoma poco por debajo
       (flota en relieve: descolgarse un poco queda natural). Si no, hacia
       arriba, sin salirse del panel. */
    var holgura = (parseFloat(getComputedStyle(u.slab).fontSize) || 14) * 0.9;
    var abajo = top + row.offsetHeight + aire + u.pop.offsetHeight <= u.prods.clientHeight + holgura;
    var y = abajo
      ? top + row.offsetHeight + aire
      : top - u.pop.offsetHeight - aire;
    u.pop.style.setProperty('--y', Math.round(y) + 'px');
  }

  function activar(u, row) {
    if (!u.pop || u.activa === row) return;
    if (u.activa) u.activa.classList.remove('is-on');
    u.activa = row;
    row.classList.add('is-on');

    var t = u.pop.querySelector('[data-kop-pop-t]');
    var lista = u.pop.querySelector('[data-kop-tallas]');
    if (t) t.textContent = row.getAttribute('data-t');

    var vals = [];
    var max = 1;
    (row.getAttribute('data-tallas') || '').split(',').forEach(function (p) {
      var kv = p.split(':');
      var n = parseInt(kv[1], 10) || 0;
      vals.push({ t: kv[0], n: n });
      if (n > max) max = n;
    });
    var filas = lista ? lista.children : [];
    for (var k = 0; k < filas.length; k++) {
      var v = vals[k];
      var f = filas[k];
      f.hidden = !v;
      if (!v) continue;
      var c = f.children; // barra · «talla cifra»
      c[0].firstElementChild.style.setProperty('--w', (Math.max(v.n / max, 0.06)).toFixed(3));
      var b = document.createElement('b');
      b.textContent = v.n;
      c[1].textContent = v.t + ' ';
      c[1].appendChild(b);
      f.classList.toggle('is-pico', v.n === max);
    }
    colocarPop(u);
  }

  // ── Foco desde las ventajas ───────────────────────────────────
  function enfocar(u, li) {
    if (u.foco) u.foco.classList.remove('is-on');
    u.foco = li;
    if (li) {
      li.classList.add('is-on');
      u.slab.setAttribute('data-focus', li.getAttribute('data-kop-feat'));
    } else {
      u.slab.removeAttribute('data-focus');
    }
  }

  function setup(root) {
    if (root.getAttribute('data-kop-ok')) return;
    var slab = root.querySelector('[data-kop-slab]');
    if (!slab) return;
    root.setAttribute('data-kop-ok', '1');
    var u = {
      root: root,
      slab: slab,
      stage: root.querySelector('[data-k3d-stage]'),
      prods: root.querySelector('[data-kop-prods]'),
      rows: Array.prototype.slice.call(root.querySelectorAll('[data-kop-prod]')),
      pop: root.querySelector('[data-kop-pop]'),
      feats: Array.prototype.slice.call(root.querySelectorAll('[data-kop-feat]')),
      activa: null,
      foco: null
    };

    var hora = root.querySelector('[data-kop-hora]');
    if (hora) hora.textContent = new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });

    // Productos: ratón al posar; dedo al tocar.
    u.rows.forEach(function (row) {
      row.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') activar(u, row); });
      row.addEventListener('click', function () { activar(u, row); });
    });
    if (u.rows.length) activar(u, u.rows[0]);

    // Ventajas: con ratón, mientras está encima; con el dedo, se alterna.
    u.feats.forEach(function (li) {
      li.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') enfocar(u, li); });
      li.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') enfocar(u, null); });
      li.addEventListener('click', function () { if (!fine.matches) enfocar(u, u.foco === li ? null : li); });
    });

    if (u.stage && 'ResizeObserver' in window) new ResizeObserver(function () { colocarPop(u); }).observe(u.stage);
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-kop]'), setup);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
